import React from 'react';

const AdPlaceholder = ({ darkMode }) => {
  return (
    <div
      className={`my-8 rounded-xl border-2 border-dashed flex items-center justify-center py-10 px-6 ${
        darkMode
          ? 'border-slate-600 bg-slate-800/50'
          : 'border-gray-200 bg-gray-50'
      }`}
    >
      <p className={`text-sm font-medium tracking-wide ${darkMode ? 'text-slate-500' : 'text-gray-400'}`}>
        Tutaj może być Twoja reklama
      </p>
    </div>
  );
};

export default AdPlaceholder;
